'use strict';

// import 'waypoints/lib/jquery.waypoints.min';

export const inview = (() => {
    const $inview = $('.js-inview');

    /**
     * init
     */
    const init = () => {
        $(window).scroll(function () {
            $inview.each((i, e) => {
                const $this = $(e)
                const $thisOuter = $this.outerHeight()
                const $thisOffset = $this.offset().top + $thisOuter

                if ($(window).scrollTop() + $(window).height() > $thisOffset) {
                    $this.addClass('is-inview')
                }
            });
        });
        $(window).on('load', function () {
            $inview.each((i, e) => {
                const $this = $(e)
                const $thisOuter = $this.outerHeight()
                const $thisOffset = $this.offset().top + $thisOuter

                if ($(window).scrollTop() + $(window).height() > $thisOffset) {
                    $this.addClass('is-inview')
                }
            });
        });
    };

    return {
        init: init
    };
})();
